import React, {useEffect, useRef, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import {Tooltip} from 'react-tooltip'
import {confirmVB, getAllDemandeDevis} from '../../../../components/requests'
import {useFilAriane} from "../../../contexts/FilArianeContext";

interface Props {
  demande: any
  handleList?: any
  setPanier?: any
  setDemandeClient?: any
}

const ConfirmVBModal = (props: Props) => {
  const {demande, handleList, setPanier, setDemandeClient} = props
  const {commandeAriane, setListePOTAriane, setSelectedPOTAriane} = useFilAriane()
  const [loading, setLoading] = useState<boolean>(false)
  const [numDevis, setNumDevis] = useState<string>('')
  const closeModalRef = useRef<HTMLDivElement | null>(null)
  const modalRef = useRef<HTMLDivElement | null>(null)

  // Liste des POT en attente
  const POTEnAttente = commandeAriane
    ?.filter((item) => (item?.pot !== null && item?.pendingPOT === true && item?.statut === 'BLOQU'))
    ?.map((item) => ({
      ...item?.pot,
      demande: demande
    })) ?? []

  useEffect(() => {
    if (!demande) return

    getAllDemandeDevis(demande.id).then((res) => {
      if (res?.status === 200 && res?.data?.[0]?.nomFichier) {
        setNumDevis(res.data[0].nomFichier.replace(/\.[^/.]+$/, ''))
      }
    })
  }, [demande])

  const confirmPay = (status: string) => {
    setLoading(true)
    try {
      confirmVB(demande?.id, status).then((requestResponse) => {
        if (requestResponse?.status === 200) {
          if (handleList) handleList(status, requestResponse.data?.clientDemande)
          if (setDemandeClient) setDemandeClient(requestResponse.data?.clientDemande)
          if (setPanier) {
            const pieceProposeeData = requestResponse.data?.clientDemandePieceProposee
            setPanier((prev) => prev?.map((item) => {
              const clientDemandePieceProposee = pieceProposeeData?.find((proposee) =>
                proposee?.pieceEntre?.id === item?.id || proposee?.typePiecePOT?.id === item?.id)

              const proposeeId = (clientDemandePieceProposee?.typePiecePOT !== null)
                ? clientDemandePieceProposee?.typePiecePOT?.id
                : clientDemandePieceProposee?.pieceEntre?.id

              if (proposeeId === item?.id) {
                const statut = clientDemandePieceProposee?.isAccepted
                  ? 'ACCEP' : ((clientDemandePieceProposee?.isAcceptedBlocked) ? 'BLOQU' : item?.statut)
                return {
                  ...item,
                  isAccepted: clientDemandePieceProposee?.isAccepted,
                  isAcceptedBlocked: clientDemandePieceProposee?.isAcceptedBlocked,
                  statut: statut,
                }
              } else return item
            }))
          }
          setLoading(false)
          if (closeModalRef.current) closeModalRef.current.click()
        }
      })
    } catch (ex) {
      console.error(ex)
    }
  }

  return (
    <div
      className='modal fade'
      id='confirmBVModal'
      aria-hidden='true'
      aria-labelledby='exampleModalToggleVB'
      tabIndex={-1}
      ref={modalRef}
    >
      <div className='modal-dialog modal-dialog-scrollable modal-lg'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title' id='exampleModalToggleVB'>
              Validation du règlement de ce devis
            </h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
              ref={closeModalRef}
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <p> Souhaitez-vous valider le devis {numDevis} actuellement "accepté bloqué" ?</p>
            <p>
              En cliquant sur valider vous confirmez que le virement a été effectué, la commande sera créée et le statut de la demande passera à
              "accepté".
            </p>
            <p> En cliquant sur refuser, le statut de la demande passera en "refusé".</p>
            {POTEnAttente?.length > 0 && (
              <>
                <div className="text-info d-flex align-items-center gap-2 py-4">
                  <i className="text-info bi bi-info-circle-fill"></i>
                  <strong>Information</strong>
                </div>
                <p>
                  {POTEnAttente?.length > 1 ? 'Plusieurs' : 'Un'} POT {POTEnAttente?.length > 1 ? 'sont' : 'est'} également prêt à être validé,
                  à la suite du virement précédemment accepté.
                </p>
                <p>Pour procéder à la validation, veuillez cliquer sur le bouton "Valider POT".</p>
              </>
            )}
          </div>
          <div className='d-flex justify-content-between modal-footer'>
            <div>
              {(POTEnAttente?.length > 0) && (
                <button
                  type='button'
                  className='btn btn-success'
                  disabled={loading}
                  data-bs-toggle='modal'
                  data-bs-target='#modalPOT'
                  data-bs-dismiss='modal'
                  onClick={() => {
                    setSelectedPOTAriane(POTEnAttente?.[0] ?? null)
                    setListePOTAriane(POTEnAttente)
                  }}
                >
                  Valider POT ({POTEnAttente?.length ?? 0})
                </button>
              )}
            </div>
            <div className='d-flex gap-2'>
              <button
                type='button'
                className='btn btn-light'
                data-bs-dismiss='modal'
                disabled={loading}
              >
                Retour
              </button>
              {loading ? (
                <button type='button' className='btn btn-light' disabled={loading}>
                <span className='indicator-progress' style={{display: 'block'}}>
                  Traitement...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
                </button>
              ) : (
                <>
                  <button
                    type='button'
                    className='btn btn-danger'
                    onClick={() => confirmPay('REFUS')}
                    disabled={loading}
                  >
                    Refuser
                  </button>
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={() => confirmPay('ACCEP')}
                    disabled={loading}
                  >
                    Valider
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <Tooltip id='modal-tooltip' />
    </div>
  )
}

export default ConfirmVBModal
